<osp-whitelabeled-component
  [componentKey]="WhitelabeledComponentKey.DASHBOARD_LAYOUT"
  [defaultComponent]="DefaultLayout"
/>
